/**
 * Marketing format presets rendered as a row of cards under the canvas — mirrors
 * the `.marketing-formats` / `.format-card` block in the reference HTML.
 */
const FORMATS = [
  { id: "flyer",     title: "Flyer",     size: "8.5 × 11 in",   desc: "Print-ready flyer canvas with bleed and safe zone guides." },
  { id: "banner",    title: "Banner",    size: "1500 × 500 px", desc: "Web banner ready for LinkedIn, X, and email headers." },
  { id: "slide",     title: "Slide",     size: "1920 × 1080 px",desc: "16:9 slide format for decks, webinars, and explainer videos." },
  { id: "social",    title: "Social Ad", size: "1080 × 1080 px",desc: "Square ad ready for Instagram, Facebook, and LinkedIn feed." },
  { id: "story",     title: "Story",     size: "1080 × 1920 px",desc: "Vertical story for Instagram, Facebook, TikTok, and YouTube." },
  { id: "thumbnail", title: "Thumbnail", size: "1280 × 720 px", desc: "YouTube thumbnail with bold title overlay." },
];

export default function FormatCardsRow({ onSelect }) {
  return (
    <section
      data-testid="md-format-row"
      aria-label="Marketing format presets"
      style={{
        width: 960,
        marginTop: 28,
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 18,
        color: "var(--pl-text)",
      }}
    >
      {FORMATS.map((f) => (
        <button
          key={f.id}
          type="button"
          data-testid={`md-format-${f.id}`}
          onClick={() => onSelect?.(f)}
          style={{
            minHeight: 132,
            borderRadius: 20,
            border: "1px solid var(--pl-border)",
            background: "rgba(255,255,255,0.045)",
            padding: 18,
            boxShadow: "0 22px 60px rgba(0,0,0,0.38)",
            color: "inherit",
            textAlign: "left",
            cursor: "pointer",
            transition: "transform .18s ease, border-color .18s ease, box-shadow .18s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.borderColor = "rgba(39,230,209,0.45)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "";
            e.currentTarget.style.borderColor = "var(--pl-border)";
          }}
        >
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            marginBottom: 8,
          }}>
            <strong style={{ fontSize: 18, lineHeight: 1.1 }}>{f.title}</strong>
            <span style={{
              fontSize: 10, fontWeight: 800, letterSpacing: "0.16em",
              textTransform: "uppercase", color: "var(--pl-aqua)",
              border: "1px solid rgba(39,230,209,0.36)",
              padding: "3px 8px", borderRadius: 999,
            }}>
              {f.size}
            </span>
          </div>
          <span style={{ color: "var(--pl-text-muted)", lineHeight: 1.4, fontSize: 13 }}>
            {f.desc}
          </span>
        </button>
      ))}
    </section>
  );
}
